module["exports"] = [
  "آقای",
  "خانم",
  "دکتر"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fa/name/prefix.js
// module id = 1120
// module chunks = 1